// extracted by mini-css-extract-plugin
module.exports = {"qrcodeBox":"qrcode_qrcodeBox_2Yfty","desc":"qrcode_desc_E0_QE"};